import { render, staticRenderFns } from "./MediaFilePicker.vue?vue&type=template&id=06ff3196&"
import script from "./MediaFilePicker.vue?vue&type=script&lang=js&"
export * from "./MediaFilePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ff3196')) {
      api.createRecord('06ff3196', component.options)
    } else {
      api.reload('06ff3196', component.options)
    }
    module.hot.accept("./MediaFilePicker.vue?vue&type=template&id=06ff3196&", function () {
      api.rerender('06ff3196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-picker/MediaFilePicker.vue"
export default component.exports